var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncorrectLogoSymbolOnly = function SvgIncorrectLogoSymbolOnly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 79.47 79.95"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#366aff",
    d: "M54.34 27.67A26.61 26.61 0 0 0 27.79 1h-.12A26.91 26.91 0 0 0 1 24.79l33.16 28.83a26.72 26.72 0 0 0 20.18-25.95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0e0fd",
    d: "M72 30.55 39.57 58.67l23.06 19.82h11.54a4 4 0 0 0 4-4V33.8c-.04-3.61-3.64-5.41-6.17-3.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ea6fd",
    d: "M1 24.79v49.74a4 4 0 0 0 4 4h57.63Z"
  })));
};
export default SvgIncorrectLogoSymbolOnly;